import { LitElement, html, css, nothing} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { CurrentLeg } from '../../../src/models/vessel-performance-model';

import './dial-performance-chart';
import './block-performance-chart';
import './current-leg-info-box';

@customElement('vessel-performance-current-leg')
export class VesselPerformanceCurrentLeg extends LitElement {
    @property({type: Object}) data: CurrentLeg | null = null;
    
    static get styles() {
        return [
            css`
            :host {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                pointer-events: none;
            }

            .legend {
                width: 315px;
                margin-top: 10px;
                height: 34px;
                display: flex;
                flex-direction: row;
                flex-grow: 1;
                justify-content: space-around;
                align-items: center;
                background: var(--neutrals-grey-10);
                color: var(--neutrals-grey-03, black);
                box-shadow: 1px 1px 5px var(--secondary-voyage-box-shadow);
                border: 1px solid var(--border-color-1, black);
            }

            .line {
                width: 18px;
                height: 0;
                margin: 3px;
                display: flex;
                align-content: center;
                font-size: 10px;
                line-height: 14px;
            }

            .line.actual {
                border: 1px solid var(--performance-viewer-actual-color);
            }

            .line.simulated {
                border: 1px solid var(--performance-viewer-simulated-color);
            }

            .line.nextleg {
                border: 1px solid var(--performance-viewer-nextleg-color);
            }

            .line.range {
                border: 1px solid var(--performance-viewer-range-color);
            }
            
            dial-performance-chart {
                margin-top: 10px;
            }

            block-performance-chart {
                margin-top: 10px;
            }

            current-leg-info-box,
            dial-performance-chart,
            block-performance-chart {
                box-shadow: 1px 1px 5px var(--secondary-voyage-box-shadow);
                border: 1px solid var(--border-color-1, black);
            }
        `];
    }

    render() {
        const showRange = (this.data && this.data!.MEPower !== undefined && this.data!.MEPower.simulated?.lower !== undefined && this.data!.MEPower.simulated?.upper !== undefined) ||
                          (this.data && this.data!.RPM != undefined && this.data!.RPM.simulated?.lower !== undefined && this.data!.RPM.simulated?.upper !== undefined);

        
        return html`
            ${this.data ?
                html `
                <current-leg-info-box .data=${this.data!.info}></current-leg-info-box>
                <block-performance-chart .data=${this.data!.RollAngle}></block-performance-chart>
                <dial-performance-chart .data=${this.data!.MEPower}></dial-performance-chart>
                <dial-performance-chart .data=${this.data!.RPM}></dial-performance-chart>
                <block-performance-chart .data=${this.data!.SOG}></block-performance-chart>
                <block-performance-chart .data=${this.data!.STW}></block-performance-chart>
    
                <div class="legend">
                    <div class="line actual"></div>Actual<div class="line simulated"></div>Simulated
                    ${showRange ? html`<div class="line range"></div>Range` : html``}
                    <div class="line nextleg"></div>Next Leg
                </div>`
                : nothing
            }
        `
    }
};
